define('glu/urlManager',['require','./model','./util'],function(require) {
    'use strict';

    var Model = require('./model'),
        util = require('./util');

    function Url(url) {
        this.value = url;
    }

    Url.prototype.params = function(options) {
        if (!options) {
            return this;
        }

        return new Url(this.value.replace(/(\(\?)?:\w+/g, function(match) {
            return options[match.replace(':', '')];
        }));
    };

    Url.prototype.query = function(options) {
        if (!options) {
            return this;
        }

        var url = this.value,
            separator = '?';

        util.each(options, function(value, key) {
            url += separator + key + '=' + encodeURIComponent(value);
            separator = '&';
        });

        return new Url(url);
    };

    Url.prototype.toString = function() {
        return this.value;
    };

    Url.prototype.replace = function() {
        return this.toString().replace.apply(this, arguments);
    };

    return Model.extend({
        urls: {},

        initialize: function() {
            this.initializeUrls();
        },

        initializeUrls: function() {
            util.each(this.urls, function(value, key) {
                this[key] = new Url(value);
            }, this);
        }
    });
});

